export const generalAppConfig = {
  projectName: 'СтрахоБот',
  projectSlug: 'strahobot',
}
